import { useContext, useMemo } from "react";
import { authContext } from "@/shared/model/authContext";
import { PERMISSIONS } from "@/shared/config/permissions";

export interface InventoryPermissionFlags {
  canListStorages: boolean;
  canListCategories: boolean;
  canListOffers: boolean;
  canListTools: boolean;
  canListStockTools: boolean;
  canListStockBalances: boolean;
  canListStocks: boolean;
  canListActionHistory: boolean;
  canListSolicitations: boolean;
  canListStockPurchaseOrders: boolean;
  canListStockOfferControls: boolean;
  // derivadas
  canAccessCatalog: boolean;
  canAccessOperation: boolean;
  canAccessLoans: boolean;
  canAccessInventory: boolean;
}

export function useInventoryPermissions(): InventoryPermissionFlags {
  const { checkPermission } = useContext(authContext);
  return useMemo(() => {
    const can = (p: string) => checkPermission(p);
    const canListStorages = can(PERMISSIONS.CAN_LIST_STORAGES);
    const canListCategories = can(PERMISSIONS.CAN_LIST_CATEGORIES);
    const canListOffers = can(PERMISSIONS.CAN_LIST_OFFERS);
    const canListTools = can(PERMISSIONS.CAN_LIST_TOOLS);
    const canListStockTools = can(PERMISSIONS.CAN_LIST_STOCK_TOOLS);
    const canListStockBalances = can(PERMISSIONS.CAN_LIST_STOCK_BALANCES);
    const canListStocks = can(PERMISSIONS.CAN_LIST_STOCKS);
    const canListActionHistory = can(PERMISSIONS.CAN_LIST_ACTION_HISTORY);
    const canListSolicitations = can(PERMISSIONS.CAN_LIST_SOLICITATIONS);
    const canListStockPurchaseOrders = can(PERMISSIONS.CAN_LIST_STOCK_PURCHASE_ORDERS);
    const canListStockOfferControls = can(PERMISSIONS.CAN_LIST_STOCK_OFFER_CONTROLS);

    const canAccessCatalog = canListCategories || canListOffers || canListTools;
    const canAccessOperation = canListStorages || canListStockTools || canListStockBalances || canListStocks || canListActionHistory || canListStockPurchaseOrders || canListStockOfferControls;
    const canAccessLoans = canListSolicitations || canListStockTools;

    return {
      canListStorages, canListCategories, canListOffers, canListTools,
      canListStockTools, canListStockBalances, canListStocks, canListActionHistory,
      canListSolicitations, canListStockPurchaseOrders, canListStockOfferControls,
      canAccessCatalog, canAccessOperation, canAccessLoans,
      canAccessInventory: canListStorages || canAccessCatalog || canAccessOperation || canAccessLoans,
    };
  }, [checkPermission]);
}
